import React from 'react'
import Apimage from '../images/app-development-banner.jpg'
const Hero = () => {
    return (
        <div>
            
            <h1>Sample Page</h1>
            
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate earum a possimus similique saepe illo eius quasi unde dolor reiciendis, magnam modi magni necessitatibus, porro praesentium! Sint aspernatur maxime non.</p>

            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate earum a possimus similique saepe illo eius quasi unde dolor reiciendis, magnam modi magni necessitatibus, porro praesentium! Sint aspernatur maxime non.</p>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate earum a possimus similique saepe illo eius quasi unde dolor reiciendis, magnam modi magni necessitatibus, porro praesentium! Sint aspernatur maxime non.</p>

            <img src={Apimage} alt="" />

        </div>
    )
}

export default Hero
